import { usePopover } from "../../../store/usePopoverStore";
import ConfirmPopover from "./confirm.component";

interface PopoverProps {
  id: string;
  title: string;
  description?: string;
  rightButton: {
    onClick: () => void;
    label?: string;
  };
}

export default function DeletePopover(props: PopoverProps) {
  const { id, title, description, rightButton } = props;

  const popPopover = usePopover((state) => state.popPopover);

  const handleClose = () => {
    popPopover(id);
  };

  return (
    <ConfirmPopover
      id={id}
      rightProps={{
        onClick: () => {
          rightButton.onClick();
          handleClose();
        },
        variant: "danger",
        label: rightButton?.label || "삭제",
      }}
    >
      <p className="w-full">{title}</p>
      <p>{description}</p>
    </ConfirmPopover>
  );
};
